import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const Banner = (props) => {
    const { content: { name, url } } = props;

    return (
        <div className={styles.banner}>
            <div>
                <span>{name}</span>
                {
                    url &&
                    <a href={url} target="_blank" rel="noreferrer">更多 <img src="https://x0.ifengimg.com/ucms/2022_03/752418662FA3AA31AA4ECAB4A5E5690BD8159DA4_size0_w16_h16.png" alt="" /></a>
                }
            </div>
        </div>
    );
};

Banner.propTypes = {
    content: PropTypes.object
};

export default errorBoundary(Banner);
